<template>
	<div class="card">
		<div class="header">
			<h3>Important Dates</h3>
		</div>

		<div v-if="keyDates.length > 0" class="content">
			<div class="date-field" v-for="(date, index) in keyDates" :key="index">
				<label>{{ date.keyDateTypeHumanized }}</label>
				<input type="text" placeholder="MM/DD/YYYY" :value="date.dateFormatted" readonly />
			</div>
		</div>
		<div class="not-found" v-else>
			<h4>No Dates Found</h4>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { defineProps } from 'vue';
	import { KeyDate } from '@/models/loans';

	defineProps<{
		keyDates: KeyDate[];
	}>();
</script>

<style scoped>
	.card {
		height: 100%;
	}

	.not-found {
		display: flex;
		justify-content: center;
	}

	.not-found h4 {
		color: #777;
		font-style: italic;
	}

	.content {
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
		gap: 16px;
	}

	.date-field {
		display: flex;
		flex-direction: column;
	}

	.date-field label {
		font-size: 14px;
		margin-bottom: 4px;
		text-wrap: nowrap;
	}

	.date-field input {
		margin-top: 4px;
		border: 1px solid #ccc;
		border-radius: 4px;
		font-size: 12px;
		height: 2rem;
	}
</style>
